import React, { FC, memo } from 'react'

import { Cart } from 'Types'

type Props = Pick<
  Cart,
  | 'absorbShopAppFee'
  | 'customFees'
  | 'hstForAppFeeMoney'
  | 'hstForAppFeeMoneyFormatted'
  | 'hstForDeliveryCostMoney'
  | 'hstForDeliveryCostMoneyFormatted'
  | 'shopAppFeeMoney'
  | 'shopAppFeeMoneyFormatted'
  | 'totalTaxMoneyFormatted'
>

const HelpOverlay: FC<Props> = ({
  absorbShopAppFee,
  customFees,
  shopAppFeeMoney,
  shopAppFeeMoneyFormatted,
  totalTaxMoneyFormatted,
  hstForDeliveryCostMoney,
  hstForDeliveryCostMoneyFormatted,
  hstForAppFeeMoney,
  hstForAppFeeMoneyFormatted,
}) => {
  return (
    <div className="text-left">
      <div className="my-1">
        <b>Tax:</b> {totalTaxMoneyFormatted}
      </div>
      {hstForDeliveryCostMoney ? (
        <div className="my-1">
          <b>Delivery Tax</b>: {hstForDeliveryCostMoneyFormatted}
        </div>
      ) : null}

      {shopAppFeeMoney && !absorbShopAppFee ? (
        <div className="my-1">
          <b>App fee</b>: {shopAppFeeMoneyFormatted}
          {hstForAppFeeMoney ? <> + {hstForAppFeeMoneyFormatted} (HST)</> : null}
        </div>
      ) : null}

      {customFees.map((cFee) => (
        <div key={cFee.id} className="my-1">
          <b>{cFee.name}</b>: {cFee.applied.format}
          {cFee.tax && cFee.appliedTax.amount ? (
            <>
              {' '}
              + {cFee.appliedTax.format} ({cFee.tax.name})
            </>
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default memo(HelpOverlay)
